import script from "./SearchChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchChips.vue?vue&type=script&setup=true&lang=ts"

import "./SearchChips.vue?vue&type=style&index=0&id=4ecde828&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecde828"]])

export default __exports__